export default __webpack_public_path__ + "static/B0171-65ec31658a45a0437b4cde8b636cbd0d.png";